import type { Audit } from "certiblok-api-manager";

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const AvailableAuditStatuses = <const>["approved", "approved-with-reserve", "rejected", "waiting", "revision"];
export const AvailableAuditStatusesWithoutWaiting = ["approved", "approved-with-reserve", "rejected", "revision"];
export const AvailableClosingStatus = ["approved", "approved-with-reserve", "rejected"];

export type AuditStatuses = typeof AvailableAuditStatuses[number];
export interface AuditRoom extends Audit {}
